import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  sceneInfoText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
  colorBlock: {
    display: 'inline-block',
    marginLeft: 3,
    marginTop: 2,
    width: 10,
    height: 10,
    border: '1px solid rgba(0,0,0, 0.3)',
  },
}))

export default useStyles
